import React, { useState, useEffect } from "react";
import axios from "axios";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function DiscountReport(props){
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [cashier, setCashier] = useState({ username: '' });
  const [rows, setRows] = useState([]);
  const [userData, setUserData] = useState([]);
  const [combinedData, setcombinedData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleStartDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setStartDate(localDate);
};
 const handleEndDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setEndDate(localDate);
};
  const handleUser = (event) => {
      setCashier({
        ...cashier,
        username: event.target.value
      });
    };
  useEffect(() => {
    try {
        axios.get(`${baseUrl}user-search/`)
        .then(function (response) {
            setUserData(response.data);
        });
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
      fetchData();
  }, [startDate, endDate, cashier]);
  useEffect(() => {
      if (combinedData.length > 0) {
        setRows(combinedData);
      }
  }, [combinedData]);

  function fetchData() {
  setIsLoading(true);
  const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
  const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';
  const url = `${baseUrl}all-collection-view/?start_date=${startDateString}&end_date=${endDateString}&cashier=${cashier.username}&mode=&status=2`;
  axios.get(url)
    .then(response => {
      setcombinedData(response.data);
      setIsLoading(false);
    })
    .catch(error => {
      console.log(error);
      setIsLoading(false);
    });
  }
    const columnsInvoiced = [
  { field: 'add_date_date', headerName: 'Date', width: 150 },
  { field: 'appt_id', headerName: 'Appointment ID', width: 150 },
  { field: 'pat__pat_id', headerName: 'Patient ID', width: 120 },
  { field: 'pat__patient', headerName: 'Patient Name', width: 200 },
  { field: 'invoice', headerName: 'Invoice/Receipt No',
    renderCell: (params) => (
      <Link to={
        params.row.invoice
          ? `/op-invoice/${params.row.invoice}`
          : params.row.lab_invoice
          ? `/lab-invoice-op/${params.row.lab_invoice}`
          : params.row.inv_invoice
          ? `/inv-invoice-op/${params.row.inv_invoice}`
          : params.row.min_invoice
          ? `/min-invoice-op/${params.row.min_invoice}`
          :''
      }
      target="_blank">
        {params.row.invoice || params.row.lab_invoice || params.row.inv_invoice || params.row.min_invoice}
      </Link>
    ),
    width: 180
  },
  {
    field: 'fee',
    headerName: 'Total Amount',
    width: 130,
    renderCell: (params) => params.row.fee || params.row.lab_tot || params.row.inv_tot || params.row.min_tot || 0,
  },
  {
    field: 'paid',
    headerName: 'Paid Amount',
    width: 130,
    renderCell: (params) => params.row.paid || params.row.lab_paid || params.row.inv_paid || params.row.min_paid || 0,
  },
  {
    field: 'balance',
    headerName: 'Balance Amount',
    width: 150,
    renderCell: (params) => params.row.balance || params.row.lab_balance || params.row.inv_balance || params.row.min_balance || 0,
  },
  {
    field: 'lab_disc',
    headerName: 'Disc Amount',
    width: 130,
    renderCell: (params) => params.row.lab_disc || params.row.inv_disc || params.row.min_disc || 0,
  },
  {
    field: 'mode',
    headerName: 'Payment Mode',
    width: 150,
    renderCell: (params) => params.row.mode || params.row.lab_pmode || params.row.inv_pmode || params.row.min_pmode || 'Unknown',
  },

  { field: 'cashier', headerName: 'Cashier', width: 120 },
];
const getRowId = (row) => row.appt_id;
const calculateTotal = (rows, field) => {
  return rows.reduce((total, row) => total + Number(row[field]) || 0, 0);
};

// Custom Footer component for "Invoiced Report" table
const FooterInvoiced = ({ rows }) => {
  let totalAmountTotal = 0;
  let TotalPaid = 0;
  let balanceTotal = 0;
  let discTotal = 0;

  rows.forEach((payment) => {
    totalAmountTotal += Number(payment.fee) || Number(payment.lab_tot) || Number(payment.inv_tot) || Number(payment.min_tot);

    if (!isNaN(payment.paid)) {
      TotalPaid += Number(payment.paid);
    } else if (!isNaN(payment.lab_paid)) {
      TotalPaid += Number(payment.lab_paid);
    } else if (!isNaN(payment.inv_paid)) {
      TotalPaid += Number(payment.inv_paid);
    } else if (!isNaN(payment.min_paid)) {
      TotalPaid += Number(payment.min_paid);
    }

    if (!isNaN(payment.balance)) {
      balanceTotal += Number(payment.balance);
    } else if (!isNaN(payment.lab_balance)) {
      balanceTotal += Number(payment.lab_balance);
    } else if (!isNaN(payment.inv_balance)) {
      balanceTotal += Number(payment.inv_balance);
    } else if (!isNaN(payment.min_balance)) {
      balanceTotal += Number(payment.min_balance);
    }

    discTotal += isNaN(payment.lab_disc) ? 0 : Number(payment.lab_disc);
    discTotal += isNaN(payment.inv_disc) ? 0 : Number(payment.inv_disc);
    discTotal += isNaN(payment.min_disc) ? 0 : Number(payment.min_disc);
  });

  return (
    <div style={{ display: 'flex', justifyContent: 'space-evenly', padding: '2px' }}>
      <div>Total</div>
      <div>{totalAmountTotal}</div>
      <div>{TotalPaid}</div>
      <div>{balanceTotal}</div>
      <div>{discTotal}</div>
      <div colSpan="2"></div>
    </div>
  );
};

  const today = new Date();

  return (
    <section className="container mt-4">
    <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i className="fa-solid fa-calendar-days"
        aria-hidden="true" style={{color: 'red'}}></i> Discount Report</h3>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label className="col-sm-3 col-lg-2 control-label">Select Date</label>
            <div className="col-sm-9 col-lg-10 controls">
            <DatePicker
                selected={startDate}
                onChange={handleStartDateChange}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                placeholderText={'Please select From date'}
                dateFormat="dd/MM/yyyy"
                showMonthDropdown
                showYearDropdown
            />
            </div>
            <div className="col-sm-9 col-lg-10 controls">
            <DatePicker
                selected={endDate}
                onChange={handleEndDateChange}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                minDate={startDate}
                maxDate={today}
                placeholderText={'Please select To date'}
                dateFormat="dd/MM/yyyy"
                showMonthDropdown
                showYearDropdown
            />
            </div>
            <div className="mb-4 mt-4">
              <label htmlFor="user" className="form-label">Search by Cashier</label>
              <select name="user" id="username" value={cashier.user} className="form-control"
                            onChange={(event) => handleUser(event)}>
                            <option value="">Select Cashier</option>
              {userData.map((User,index) => (
                <option key={index} value={User.username}>{User.username}</option>
              ))}
            </select>
            </div>
            </div>
        </div>
      </div>
{!isLoading && combinedData.length > 0 && (
          <div>
            <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
              <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
              Discount
            </h3>
            <div style={{ height: "100%", width: '100%' }}>
              <DataGrid
                sx={{
                  boxShadow: 4,
                  border: 4,
                  borderColor: 'primary.light',
                  '& .MuiDataGrid-cell:hover': {
                    color: 'primary.main',
                  },
                }}
                getRowId={getRowId}
                rows={combinedData.filter(payment => (payment.disc > 0 || payment.lab_disc > 0 || payment.inv_disc > 0 || payment.min_disc > 0))}
                columns={columnsInvoiced}
                pageSize={10}
                slots={{
                  toolbar: GridToolbar,
                }}
                autoHeight
              />
              <table className="mt-4" style={{ width: '100%', borderCollapse: 'collapse' }}>
            <tfoot>
              <FooterInvoiced rows={combinedData.filter(payment => (payment.disc > 0 || payment.lab_disc > 0 || payment.inv_disc > 0 || payment.min_disc > 0))} />
            </tfoot>
          </table>
            </div>
          </div>
        )}
    </section>
  )
}

export default DiscountReport;
